export default __webpack_public_path__ + "static/media/rmperformance_icon.2fe9e778.svg";